/**
 * @interface
 */
export class IFlotiqPluginEvent {
  constructor(initData) {
    Object.assign(this, initData);
  }
}
